import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState, } from 'react';
import ResponsiveTable, { empiricalScrollHeightAdjust, } from 'components/ResponsiveTable';
import { toSpeakerRows } from './toSpeakerRows';
import { useColumns } from './useColumns';
import styles from './style.module.less';
const SCROLL_HEIGHT_ADJUST = empiricalScrollHeightAdjust(215);
export const defaultSieve = { sortBy: 'lastUpdated', sortOrder: 'descend', filterDates: [] };
const textMatchesQuery = (text, query) => (text.toLowerCase().includes(query.toLowerCase()));
const rowMatchesQuery = (row, query) => {
    var _a;
    return (textMatchesQuery(`${(_a = row.firstName) !== null && _a !== void 0 ? _a : ''} ${row.lastName}`, query)
        || row.roles.some((r) => textMatchesQuery(r, query)));
};
const SpeakersTable = ({ contentHeight, speakers, tableView, onFetch, onSpeakerModalChange, onSelectChange, selectedSpeakers, languages, }) => {
    var _a, _b, _c;
    const columns = useColumns(onSpeakerModalChange, tableView, speakers.status === 'success', onFetch, languages);
    const [expandedRowKeys, setExpandedRowKeys] = useState([]);
    const searchQuery = (_a = tableView.getViewParams().sieve) === null || _a === void 0 ? void 0 : _a.search;
    const isOneLanguage = languages !== undefined && languages.length === 1;
    const speakerRows = useMemo(() => (speakers.data !== null ? toSpeakerRows(speakers.data.entries, languages) : []), [speakers, languages]);
    useEffect(() => {
        if (searchQuery === undefined || searchQuery === '') {
            setExpandedRowKeys([]);
            return;
        }
        if (speakers.status !== 'success') {
            return;
        }
        const keys = [];
        speakerRows.forEach((row) => {
            var _a, _b;
            const childOrGrandchildMatches = (child) => {
                var _a;
                return (rowMatchesQuery(child, searchQuery)
                    || ((_a = child.children) === null || _a === void 0 ? void 0 : _a.some((gc) => rowMatchesQuery(gc, searchQuery))) === true);
            };
            if (((_a = row.children) === null || _a === void 0 ? void 0 : _a.some(childOrGrandchildMatches)) === true) {
                keys.push(row.key);
            }
            (_b = row.children) === null || _b === void 0 ? void 0 : _b.forEach((child) => {
                var _a;
                if (((_a = child.children) === null || _a === void 0 ? void 0 : _a.some((gc) => rowMatchesQuery(gc, searchQuery))) === true) {
                    keys.push(child.key);
                }
            });
        });
        setExpandedRowKeys(keys);
    }, [speakerRows, searchQuery, speakers.status]);
    const rowSelection = {
        selectedRowKeys: selectedSpeakers,
        preserveSelectedRowKeys: true,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: record.rowType === 'variant' || (record.rowType === 'localization' && !isOneLanguage),
        }),
        columnWidth: 40,
        renderCell: (_, record, _i, originNode) => {
            if (record.rowType === 'variant' || (record.rowType === 'localization' && !isOneLanguage)) {
                return null;
            }
            return originNode;
        },
        align: 'center',
    };
    return (_jsx(ResponsiveTable, { tableView: tableView, onViewChange: onFetch, dataSource: speakerRows, recordCount: (_c = (_b = speakers.data) === null || _b === void 0 ? void 0 : _b.totalCount) !== null && _c !== void 0 ? _c : 0, columns: columns, rowKey: (record) => record.key, loading: speakers.status === 'loading', className: styles.table, scroll: { y: contentHeight - SCROLL_HEIGHT_ADJUST }, expandable: {
            indentSize: 45,
            showExpandColumn: true,
            expandedRowKeys,
            onExpand: (expanded, record) => {
                setExpandedRowKeys((prev) => (expanded ? [...prev, record.key] : prev.filter((k) => k !== record.key)));
            },
        }, rowSelection: rowSelection }));
};
export default SpeakersTable;
